import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 14.4c1.697 0 3.325-.674 4.525-1.874 1.2-1.2 1.875-2.829 1.875-4.526 0-1.697-.674-3.325-1.875-4.525C11.325 2.275 9.697 1.6 8 1.6c-1.697 0-3.325.674-4.526 1.875C2.274 4.675 1.6 6.303 1.6 8c0 1.697.674 3.325 1.874 4.526C4.674 13.726 6.303 14.4 8 14.4zm2.966-7.434c.145-.151.226-.353.224-.563-.002-.21-.086-.41-.234-.559-.149-.148-.35-.232-.559-.234-.21-.002-.412.079-.563.224L7.2 8.47 6.166 7.435c-.151-.146-.353-.227-.563-.225-.21.002-.41.086-.559.234-.148.149-.232.35-.234.559-.002.21.079.412.224.563l1.6 1.6c.15.15.354.234.566.234.212 0 .416-.084.566-.234l3.2-3.2z",
  "clip-rule": "evenodd"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}